// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const RemoveFromOrgSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RemoveFromOrgContent = styled.p`
  padding-left: 8px;
`;

export const Bold = styled.b`
  font-weight: 600;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
